// extracted by mini-css-extract-plugin
export default {"root":"DeliveryPlaces_root__TkHq0","grid":"DeliveryPlaces_grid__qsYEY","header":"DeliveryPlaces_header__OSWf6"};